const state = {
    stepper: {
        steps: [
            {
                label: "Personal Details", // The label of the step on the front end/onboarding process
                status: "", // Used to determine whether the step has passed validation on the front end or not
                admin_icon: "personal-details", // Used for the icon of the step in the admin panel
                admin_label: "Personal Details", // Used for the label of the step in the admin panel
                admin_anchor_link: 'personal-details',
            },
            {
                label: "Employment Details",
                status: "",
                admin_icon: "employment-details",
                admin_label: "Employment Details",
                admin_anchor_link: 'employment-details',
            },
            {
                label: "Investment Experience",
                status: "",
                admin_icon: "investment-experience",
                admin_label: "Investment Experience",
                admin_anchor_link: 'investment-experience',
            },
            {
                label: "Investment Objectives",
                status: "",
                admin_icon: "investment-objectives",
                admin_label: "Investment Objectives",
                admin_anchor_link: 'investment-objectives',
            },
            {
                label: "Financial Circumstances",
                status: "",
                admin_icon: "financial-circumstances",
                admin_label: "Financial Circumstances",
                admin_anchor_link: 'financial-circumstances',
            },
            {
                label: "Banking Details",
                status: "",
                admin_icon: "banking-details",
                admin_label: "Banking Details",
                admin_anchor_link: 'banking-details',
            },
            {
                label: "Legal Documentation",
                status: "",
                admin_icon: "legal-documentation",
                admin_label: "Legal Documentation",
                admin_anchor_link: 'legal-documentation',
            },
            {
                label: "Declarations",
                status: "",
                admin_icon: "legal-documentation",
                admin_label: "Final Confirmations & Submission",
                admin_anchor_link: 'declarations',
            },
        ],
    },
};

const getters = {
    stepper: (state) => state.stepper,
};

const actions = {
    async doSetStepperStepStatus({ commit }, stepDetails) {
       commit("setStepperStepStatus", stepDetails);
    },
};

const mutations = {
    setStepperStepStatus: (state, stepDetails) => {
        state.stepper.steps[stepDetails.step].status = (stepDetails.status != undefined && stepDetails.status) ? stepDetails.status : "";
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
